module.exports = __webpack_public_path__ + "img/fontawesome-webfont.6878d55.svg";